import React from 'react'

const HouseholdMembersOnPolicy = ({ context, changeClass, method }) => {
  var storedMembers = changeClass?.driversHHMs?.householdMembers?.storedMembers

  return (
    <>
      <h5 className='text-primary text-center fw-bold my-3'>HOUSEHOLD MEMBERS</h5>

      <p className="text-center fw-bold">
        Your policy has the below household member(s) that currently live at the policy address and do not operate the
        policy vehicle(s) - including children even if away at school:
      </p>

      <div className="row justify-content-center mb-3">
        <div className="col-xl-8 col-lg-8 col-md-8">

          {/* Stored Household Members */}
          {storedMembers.map((hhm, index) => {
            return (
              <div key={index}>
                {/* Driver details in grid columns */}
                <div className="row mb-2 align-items-center">
                  <div className="col-4">
                    <span className="fw-bold">{hhm.fullName}</span>
                  </div>
                  <div className="col-4">
                    <span className='col-4'> DOB ({hhm.DOB})</span>
                  </div>
                  <div className="col-4 text-end">
                    <button type="button" className={`btn btn-default pull-right text-primary editCancelBtn`} value={"UpdateHHM"} style={{ width: "75%" }}
                      onClick={(e) => method(e.target.value, index)}
                    >
                      Update
                    </button>
                  </div>
                </div>
                <hr className="less-margin" />
              </div>
            )
          })}

        </div>
      </div>
    </>
  )
}

export default HouseholdMembersOnPolicy